<script lang="ts">
  import DropDownButton from '../buttons/DropDownButton.svelte';
  import FormStyledButton from '../buttons/FormStyledButton.svelte';
  import FormStyledDropDownButton from '../buttons/FormStyledDropDownButton.svelte';
  import Link from '../elements/Link.svelte';
  import LoadingInfo from '../elements/LoadingInfo.svelte';
  import TableControl from '../elements/TableControl.svelte';
  import SelectField from '../forms/SelectField.svelte';
  import FontIcon from '../icons/FontIcon.svelte';
  import { apiCall } from '../utility/api';
  import { showSnackbarInfo } from '../utility/snackbar';
  import ConfirmModal from './ConfirmModal.svelte';
  import ModalBase from './ModalBase.svelte';
  import { closeCurrentModal, showModal } from './modalTools';

  // *** This file is part of DbGate Premium ***

  export let folid;
  export let name;

  let refreshToken = 0;

  async function changeRole({ email, role }) {
    await apiCall('cloud/set-folder-user-role', { email, role, folid });
    refreshToken++;
  }

  async function removeRole(email) {
    showModal(ConfirmModal, {
      message: `Are you sure you want to remove user ${email} from folder ${name}?`,
      confirmText: 'Remove',
      onConfirm: async () => {
        await apiCall('cloud/remove-folder-user', { email, folid });
        refreshToken++;
      },
    });
  }

  const handleCopyInviteLink = async role => {
    const { inviteToken } = await apiCall(`cloud/get-invite-token`, {
      folid,
      role,
    });
    if (inviteToken) {
      const inviteLink = `dbgate://folder/v1/${inviteToken}?mode=${role}`;
      navigator.clipboard.writeText(inviteLink);
      showSnackbarInfo(`Invite link (${role}) copied to clipboard`);
    }
  };
</script>

<ModalBase {...$$restProps}>
  <svelte:fragment slot="header">Administer shared folder {name}</svelte:fragment>

  {#await apiCall('cloud/folder-users', { folid, refreshToken })}
    <LoadingInfo message="Loading folder users" wrapper />
  {:then users}
    <TableControl
      columns={[
        { header: 'User email', fieldName: 'email' },
        { header: 'Role', fieldName: 'role', slot: 1 },
        { header: '', fieldName: 'actions', slot: 2 },
      ]}
      rows={users}
    >
      <svelte:fragment slot="1" let:row>
        <SelectField
          isNative
          style="min-width:calc(100% - 9px)"
          value={row.role}
          on:change={e => {
            changeRole({ ...row, role: e.detail });
          }}
          options={['admin', 'read', 'write'].map(x => ({ label: x, value: x }))}
        />
      </svelte:fragment>
      <svelte:fragment slot="2" let:row>
        <Link onClick={() => removeRole(row.email)}>Remove</Link>
      </svelte:fragment>
    </TableControl>
  {/await}

  <div class="m-2 mt-4">
    <FontIcon icon="img info" padRight />
    For adding users to this folder, copy invitation link below and send it to them.
  </div>

  <svelte:fragment slot="footer">
    <FormStyledButton value="Close" on:click={closeCurrentModal} />
    <FormStyledDropDownButton
      value="Copy invitation link"
      skipWidth
      menu={[
        {
          text: 'Admin',
          onClick: () => handleCopyInviteLink('admin'),
        },
        {
          text: 'Write',
          onClick: () => handleCopyInviteLink('write'),
        },
        {
          text: 'Read',
          onClick: () => handleCopyInviteLink('read'),
        },
      ]}
    />
  </svelte:fragment>
</ModalBase>
